import type { Socket } from 'socket.io-client';
import { useAuthStore } from '@/shared/stores/authStore';
import { connectSocket, disconnectSocket, getSocket } from './socket';

let currentToken: string | null = null;

export const initSocketLifecycle = (): void => {
  const apply = (token: string | null): void => {
    if (token === currentToken) return;
    const previous = currentToken;
    currentToken = token;
    if (!token) {
      disconnectSocket();
      return;
    }
    // Se ja existia um token (refresh durante o evento), derruba a conexao
    // anterior antes de criar uma nova com o token renovado. Garante que o
    // socket nao fique amarrado ao token expirado quando o handshake estiver
    // sendo validado servidor-side.
    if (previous) disconnectSocket();
    const sock = connectSocket(token);
    sock.on('connect_error', (err: Error) => {
      // eslint-disable-next-line no-console
      console.warn('[socket] connect_error', err.message);
    });
  };

  apply(useAuthStore.getState().accessToken);
  useAuthStore.subscribe((state) => {
    apply(state.accessToken);
  });
};

export const getActiveSocket = (): Socket | null => getSocket();
